import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            padding: '40px',
            textAlign: 'center',
            color: '#666',
            background: '#f9f9f9',
            border: '1px solid #ddd',
            borderRadius: '8px',
            margin: '20px'
          }}
        >
          <h3 style={{ color: '#e53935' }}>⚠ Terjadi Kesalahan</h3>
          <p>Halaman ini tidak dapat ditampilkan.</p>
          <details style={{ marginTop: '10px', fontSize: '12px', color: '#999' }}>
            <summary>Detail Error</summary>
            <pre style={{ textAlign: 'left', overflow: 'auto', marginTop: '8px' }}>
              {this.state.error && this.state.error.toString()}
            </pre>
          </details>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: '16px',
              padding: '8px 24px',
              background: '#1976d2',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Refresh Halaman
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
